module.exports = __webpack_public_path__ + "static/media/unix_video_2.a30b5831.gif";